'use client';

import clsx from 'clsx';
import BasicLink from 'core/BasicLink';
import React, { useEffect, useState } from 'react';

import cn from './style.module.sass';

type CommonNavProps = {
    stepOne?: string;
    stepTwo?: string;
    stepThree?: string;
    stepFour?: string;
    className: string;
    link1: string | boolean;
    link2: string | boolean;
    link3?: string | boolean;
    seo?: boolean;
    ppc?: boolean;
};

function CommonNav({
    stepOne,
    stepTwo,
    stepThree,
    stepFour,
    className = '',
    link1,
    link2,
    link3,
    seo,
    ppc,
}: CommonNavProps) {
    const [path, setPath] = useState('');

    useEffect(() => {
        switch (stepThree?.toLowerCase()) {
            case 'маркетинг': {
                setPath('marketing');
                break;
            }

            case 'разработка': {
                setPath('development');
                break;
            }

            case 'продукты': {
                setPath('products');
                break;
            }
            default: {
                setPath('');
            }
        }
    }, [stepThree]);

    return (
        <div className={clsx(cn.nav, cn[`${className}`])}>
            <BasicLink className={cn['nav__link']} href={link1 as string}>
                {stepOne}
            </BasicLink>{' '}
            /{' '}
            <BasicLink className={cn['nav__link']} href={link2 as string}>
                {stepTwo}
            </BasicLink>{' '}
            {link3 && !ppc && (
                <>
                    /{' '}
                    <BasicLink className={cn['nav__link']} href={`${link2}/${path}`}>
                        {stepThree}
                    </BasicLink>
                </>
            )}
            {link3 && ppc && (
                <>
                    /{' '}
                    <BasicLink className={cn['nav__link']} href={link3 as string}>
                        {stepThree}
                    </BasicLink>
                </>
            )}
            {seo && <>/ {stepThree}</>}
            {ppc && <>/ {stepFour}</>}
        </div>
    );
}

export default CommonNav;
